// NOTE TO MYSELF:
// the whole code in this file is only evoked when lazyloading is turned off. otherwise, vanilla-lazyload library loads the images and videos

import { Utility, roundUpSizes } from './utility_controller'

// this is just for when layData.image_loading is "instant_load"
var loadImage = function ($img) {
	if ($img.hasClass('setsizes')) {
		if ($img.attr('sizes') == '') {
			var rect = $img[0].getBoundingClientRect()
			var w = roundUpSizes(rect.width)

			// vanilla-lazyload js library needs data-sizes attribute, so i just set both sizes and data-sizes :)
			jQuery(this)
				.attr('sizes', w + 'px')
				.attr('data-sizes', w + 'px')
		}
		var srcset = $img.attr('data-srcset')
		// var src = $img.attr('data-src')
		$img.attr({
			// src: src,
			srcset: srcset,
		})
	} else if ($img.hasClass('lay-gif') || $img.hasClass('lay-image-original')) {
		var src = $img.attr('data-src')
		$img.attr('src', src)
	}
}

// var isInsideViewportHeight = function(el, offset = 0) {
//     var rect = el.getBoundingClientRect();
//     // todo: shouldnt this be: rect.bottom > 0 ??
// 	if(rect.top <= window.innerHeight && rect.height > 0 + offset ){
// 		return true;
// 	}else{
// 		return false;
// 	}
// }

var isInsideViewportHeight = function (el, offset = 0) {
	var fpEnabled = jQuery('html').hasClass('fp-enabled')
	// if (!fpEnabled || (fpEnabled && window.getComputedStyle(jQuery(el).closest('.row')[0]).visibility != 'hidden')) {
	if (!fpEnabled || (fpEnabled && jQuery(el).closest('.row').length > 0 && window.getComputedStyle(jQuery(el).closest('.row')[0]).visibility != 'hidden')) {
		var rect = el.getBoundingClientRect()
		if (rect.bottom > 0 && rect.top < window.innerHeight + offset && rect.right > 0 && rect.left < window.innerWidth) {
			return true
		}
	}
	return false
}

var arrayElIsTrue = function (element, index, array) {
	return element == true
}

function LoadImages($target) {
	var $parent = $target
	var imagesInViewport = []
	var imagesInViewportHaveLoaded = []
	var imagesOutsideOfViewport = []

	var loadImages = function () {
		var $images_to_load = $parent.find('img.setsizes, img.lay-gif, img.lay-image-original')

		$images_to_load.each(function () {
			if (isInsideViewportHeight(this)) {
				imagesInViewport.push(this)
				imagesInViewportHaveLoaded.push(false)
			} else {
				imagesOutsideOfViewport.push(this)
			}
		})

		// set src, srcset and sizes of images in viewport
		for (var i = 0; i < imagesInViewport.length; i++) {
			;(function (index) {
				var $img = jQuery(imagesInViewport[index])

				loadImage($img)

				if ($img[0].complete) {
					imagesInViewportHaveLoaded[index] = true
				} else {
					$img[0].addEventListener('load', function () {
						imagesInViewportHaveLoaded[index] = true
					})
					$img[0].addEventListener('error', function () {
						imagesInViewportHaveLoaded[index] = true
					})
				}
				// todo: polyFillResponsiveImages
			})(i)
		}

		if (imagesInViewport.length > 0) {
			var interval = setInterval(function () {
				// https://developer.mozilla.org/de/docs/Web/JavaScript/Reference/Global_Objects/Array/every
				if (imagesInViewportHaveLoaded.every(arrayElIsTrue)) {
					loadImagesOutsideOfViewport()
					clearInterval(interval)
				}
			}, 30)
		} else {
			loadImagesOutsideOfViewport()
		}
	}

	var loadImagesOutsideOfViewport = function () {
		// lol, all images have loaded
		// now load other images

		for (var i = 0; i < imagesOutsideOfViewport.length; i++) {
			var $img = jQuery(imagesOutsideOfViewport[i])
			loadImage($img)
		}
	}

	return {
		loadImages: loadImages,
	}
}

// this is called twice, for footer and main region, because this is called by load_cpl_or_desktop_content_controller
// this means if there are images inside the footer they will be loaded at the same time as in viewport height images in main region are loaded
// thats not optimal but it is ok for now
var initLoadImages = function ($target) {
	if ($target.length > 0) {
		// note to myself: this only gets called when lazyloading is off :D

		// not sure why, but on an iphone, especially when using a masonry thumbnailgrid,
		// loading images by first loading the in-viewport ones, and then the others is extremely slow
		// todo: see why this happens
		// that's why i just load all images on a touchdevice instantly, without waiting for the in-viewport ones to have loaded
		if (Utility.isTouchDevice) {
			var $images_to_load = $target.find('img.setsizes, img.lay-gif, img.lay-image-original')
			$images_to_load.each(function () {
				loadImage(jQuery(this))
			})
		} else {
			var loadImagesObject = new LoadImages($target)
			loadImagesObject.loadImages()
		}
	}
}

//
var load_visible_images_then_rest_controller = {
	initLoadImages: initLoadImages,
	loadImage: loadImage,
	isInsideViewportHeight: isInsideViewportHeight,
}

export { load_visible_images_then_rest_controller }
